export default defineAppConfig({
    icon: {
        /**
         * Globally set a default stroke width of 1.5 for all lucide icons.
         *
         * Using svg-mode is required for this to work: `<Icon mode="svg" />`
         */
        customize: (content: string, _name: string, prefix: string, _provider: string) => {
            if (prefix === 'lucide') {
                return content.replace(/stroke-width="[^"]*"/g, `stroke-width="1.5"`);
            }
            return content;
        }
    }
});
